import { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppContext } from '@/app/providers/AppContextProvider';
import statusConfig from '../../config/status.json';
import { useAppStatePolling } from './useAppStatePolling';

export const useStatusRouting = () => {
	const navigate = useNavigate();
	const { id } = useParams<{ id: string }>();
	const context = useAppContext();
	if (!context) {
		throw new Error('useStatusRouting must be used within AppContextProvider');
	}
	const { appData } = context;

	useAppStatePolling({ id, enabled: true });

	const handleStatusChange = useCallback(
		(status: string) => {
			if (
				statusConfig.groups.isComplete.includes(status) ||
				statusConfig.groups.pendingQuotes.includes(status)
			) {
				navigate(`/aanbod/${id}`);
				return;
			}
		},
		[id, navigate]
	);

	useEffect(() => {
		if (appData?.status) {
			handleStatusChange(appData?.status);
		}
	}, [appData?.status, handleStatusChange]);
};
